import React, { useEffect, useState } from "react";

import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkUploadCarrierChangeActions from "../../store/actions/BulkUploadCarrierChangeManager";
import BulkUploadFile from "../BulkUploadFile";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Provide feid as FEXXXXX.",
  "Provide carrier_id as id of carrier.",
  "Please refrain from putting anything else in columns other then the two (feid,carrier_id), as it may effect the processing of the file and can result in failures.",
];

const FileUploadModal = ({ getUploadUrl }) => {
  return (
    <BulkUploadCarrierChangeModal>
      <BulkUploadFile
        instructions={instructions}
        btnDataTestID="BulkUploadCarrierChangeActionsUpload"
        uploadUrl="/bulk-upsert-carrier/ack"
        sampleURL="/sample/update_carrier.csv"
        id="bulkUploadCarrierChangeModal"
        sendExtraAck={true}
        keyName="callback_key"
        heading="Bulk Upload Carrier Change Manager"
        useUserUploadedFilename={true}
        getUploadUrl={getUploadUrl}
        validationType="BulkUploadCarrierChange"
        maxSize={0.5} // in mb
      />
    </BulkUploadCarrierChangeModal>
  );
};

const BulkUploadCarrierChangeModal = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    getUploadUrl: bindActionCreators(
      BulkUploadCarrierChangeActions.bulkUploadCarrierChange,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(FileUploadModal);
